<section class="preheader no-print firstBlck">
  <section class="col-lg-12 col-md-12 col-sm-12 col-xs-12 float-right mb-4">
    <section class="col-lg-5 col-md-5 col-sm-0 col-xs-12 p0 float-left emptyheader">
      <h1 class="confirmation-title">Thank You For Your Request</h1>
    </section>
    <section class="col-lg-3 col-md-3 col-sm-6 col-xs-12 middle-row mt0 text-right float-left backBtn">
      <a (click)="navigateBack()" target="" id="backToPatEdu" data-di-id="#backToPatEdu">
        <img [src]="'../../assets/icons/'+baseSiteId+'/chevron-left.svg'" alt="chevron_left"
          class="chevron-left continue-icon">
        Back to patient education
      </a>
    </section>
    <section class="col-lg-4 col-md-4 col-sm-6 col-xs-12 text-right float-right p0 header-links">
      <section class="save-document save-document-container mb1 mt0 printBlock">
        <a href="javascript:void(0)" onclick="window.print();" target="" id="printLinkId" class="print-cart-img-section"
          data-di-id="#printLinkId">
          <img [src]="'../../assets/icons/'+baseSiteId+'/print.svg'" alt="printer">
          <span>
            Print

          </span></a>
      </section>
    </section>
  </section>
</section>
<section class="secondBlck">
  <div class="div-style row col-md-12">
    <div class="col-md-8 div-margin" *ngIf="requestedItemList?.length==0">
      {{'patientEducation.emptyRequestMsg'|cxTranslate}}
    </div>
    <div *ngIf="requestedItemList?.length>0" class="col-md-8">
      <section class="margin-title mt-3">
        <h3 class="title-style">
          <img src="../../../assets//icons/confirmation-positive-green.png" alt="">
          {{'patientEducation.confirmationTitle'|cxTranslate}}
        </h3>
        <span class="confirmation-txt">{{'patientEducation.confirmationSubtitle'|cxTranslate}}</span><br />
      </section>
      <div id="location-box" class="div-style" *ngIf="isLocationSelected">
        <div class="locationIcon">
          <img class="locationicon-align mr-1 mb-1" [src]="'../../assets/icons/'+baseSiteId+'/location.svg'"
            alt="location" />
        </div>
        <div class="locationDetails">
          <span class="selected-loc">{{ selectedLoc }}</span>
        </div>
      </div>
      <div class="div-margin need-assistance" *ngFor="let item of requestedItemList">

        <div class="row mr-0 ml-0">
          <div class="col-md-2 margin-style">
            <a href="javascript:void(0);">
              <img class="image-align" [src]="item.url">
            </a>
          </div>
          <div class="col-md-7">
            <div class="item-name">{{item.name}}</div>
            <div class="mt-2 desc-style">{{item.desc}}</div>
            <div class="mt-2 prodcode-style">{{item.code}}</div>
          </div>
          <div class="col-md-3 units mt-4">
            <span class="unit-style">{{'Units'}}</span>
            <section class="unit-area">
              <input disabled type="number" class="prod-quantity text-center" [value]="item.units" (keyup)="performQuantityComputation(null,item?.code,
          100,item?.unit)" onkeypress="return /[0-9a-zA-Z]/i.test(event.key)" id="{{'prodQuantity'+item?.code}}"
                maxlength="4" appNoMouseScroll />
              <section class="dosessection" id="{{'noOfDoses'+item?.code}}">
                {{item?.calValue}} {{item?.unit}}</section>
            </section>
          </div>
          <!-- <div class="w-100"></div> -->
          <!-- <div class="col-md-1">
        <span class="del-icon">Delete</span>
      </div> -->
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <section class="acc-information">
        <p>
          {{'patientEducation.information'|cxTranslate}}
        </p>
        <div class="row">
          <span class="col-md-5">{{'patientEducation.accountName'|cxTranslate}}</span>
          <span class="col-md-7">{{accountInformation?.name}}</span>
        </div>
        <div class="row">
          <span class="col-md-5">{{'patientEducation.accountNumber'|cxTranslate}}</span>
          <span class="col-md-7">{{accountInformation?.uid}}</span>
        </div>
        <div class="row">
          <span class="col-md-5">{{'patientEducation.phoneNumber'|cxTranslate}}</span>
          <span class="col-md-7">{{accountInformation?.phone}}</span>
        </div>
        <div class="row">
          <span class="col-md-5">{{'patientEducation.emailAddress'|cxTranslate}}</span>
          <span class="col-md-7">{{accountInformation?.email}}</span>
        </div>
      </section>
    </div>
  </div>
</section>